import React from 'react';
import arrowLeft from './arrow-left.svg';
import arrowRight from './arrow-right.svg';
import arrowDown from './arrow-down.svg';
import arrowLeftDark from './arrow-left-dark.svg';
import arrowRightDark from './arrow-right-dark.svg';
import arrowDownDark from './arrow-down-dark.svg';

export interface ArrowProps {
  direction: 'left' | 'right' | 'down';
  color?: 'primary' | 'dark';
  className?: string;
  style?: any;
  slot?: string;
}

const ArrowIcon = ({
  direction,
  color = 'primary',
  className,
  style,
  slot,
}: ArrowProps) => {
  let icon;
  switch (direction) {
    case 'left':
      icon = color === 'dark' ? arrowLeftDark : arrowLeft;
      break;
    case 'right':
      icon = color === 'dark' ? arrowRightDark : arrowRight;
      break;
    case 'down':
      icon = color === 'dark' ? arrowDownDark : arrowDown;
      break;

    default:
      break;
  }

  return (
    <img
      src={icon}
      alt="arrow"
      {...(className && { className })}
      {...(style && { style })}
      {...(slot && { slot })}
    />
  );
};

export default ArrowIcon;
